import { createFileRoute } from '@tanstack/react-router';
import ScoutPage from '../../../pages/scout/ScoutPage';

export const Route = createFileRoute('/_authenticated/$owner/scout')({
  component: RouteComponent
});

function RouteComponent() {
  return <ScoutPage />;
}
